import React from 'react'
import WebhookPixPagamentoListPageContainer from './WebhookPixPagamentoListPageContainer'

export class WebhookPixPagamentoListPage extends React.Component {
  render() {
    return <WebhookPixPagamentoListPageContainer {...this.props} />
  }
}
